// A report opened from another screen arrives with its filter already decided. Recipe Planning
// opens the Recipe Feedback and Ingredient Consumed reports for the menu item whose panel the
// button was pressed on, over the past year, and Recipe Master for that item's own recipe.
//
// The choice travels in the query string because window.open carries no router state -- the new
// tab is a fresh page load with nothing of the old one but its URL. The filter components read
// it back through readReportLink below and submit themselves once.

// Today, and the same day a year ago, in the yyyy-mm-dd the date inputs use. Same idiom the
// filters already use for their own defaults.
const pastYearRange = () => ({
    fromDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().split('T')[0],
    toDate: new Date().toISOString().split('T')[0],
});

// The query string for a report link: one menu item, over the past year.
const reportLinkQuery = (menuItemId) => {
    const { fromDate, toDate } = pastYearRange();
    const params = new URLSearchParams({ fromDate, toDate });
    if (menuItemId) params.set('item', String(menuItemId));
    return `?${params.toString()}`;
};

// The query string for a report on ONE day's session -- what the Consumption Report's Date
// column opens the Raw Report with. Both ends of the range are that day, so the report lands on
// the single session the date was clicked in rather than a window around it.
const dateSessionLinkQuery = (date, sessionId) => {
    // Any ISO timestamp down to its calendar day, the form the date inputs take.
    const day = String(date ?? '').slice(0, 10);
    const params = new URLSearchParams({ fromDate: day, toDate: day });
    if (sessionId !== null && sessionId !== undefined && sessionId !== '') {
        params.set('session', String(sessionId));
    }
    return `?${params.toString()}`;
};

// What a filter finds when the screen was opened from such a link, or null when it was opened
// any of the ordinary ways -- which is every other entry into these reports, so a filter that
// gets null must behave exactly as it did before.
const readReportLink = (search) => {
    const params = new URLSearchParams(search ?? '');
    const item = params.get('item');
    const fromDate = params.get('fromDate');
    const toDate = params.get('toDate');
    // A linked session narrows the filter to that one, in place of the two it opens on.
    const session = params.get('session');
    if (!item && !fromDate && !toDate && !session) return null;
    return { item, fromDate, toDate, session };
};

export { pastYearRange, reportLinkQuery, dateSessionLinkQuery, readReportLink };
